import { notification } from "antd";
import React from "react";

const NotificationAddToCartSuccess = (props: any) => {
  const { productName, productFeature } = props;
  return notification.success({
    message: <span style={{ fontWeight: 600 }}>Đã thêm vào giỏ hàng!</span>,
    description: (
      <>
        <p>{productName}</p>
        <p>{productFeature}</p>
      </>
    ),
    duration: 2,
  });
};

export default NotificationAddToCartSuccess;
